import { store } from 'redux/store';
import { apiInterceptor } from 'utils/apiInterceptor';

export async function getSpeakerImportLogs({
    projectId,
    sortBy = 'createdAt',
    sortOrder = 'desc',
    page = 1,
    limit = 10,
}) {
    const user = store?.getState()?.user;

    if (user) {
        const response = await apiInterceptor(
            `${process.env.REACT_APP_MYXP_API}/manager/livestream/speakers/import-logs?projectId=${projectId}&sortBy=${sortBy}&sortOrder=${sortOrder}&page=${page}&limit=${limit}`,
            {
                method: 'GET',
            }
        );

        return await response.json();
    }
}
